import React from 'react';
import Swal from 'sweetalert2';
import { post } from '../../ApiServices/ApiServices';

const CancelFun = ({ url, onCancleSuccess, status, requestedByUserId }) => {

    const handleCancel = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: " you want to cancel this order ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: 'rgba(175, 66, 66, 0.81)',
            confirmButtonText: 'Yes, cancel it!',
            cancelButtonText: 'No',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    if (!requestedByUserId) {
                        console.error("Invalid requested_by_user_id");
                        return;
                    }
                    const Data = {
                        status_id: status || 4, // Assuming 4 is the status for cancelled orders
                        requested_by_user_id: Number(requestedByUserId),
                    };
                    const response = await post(url, Data);
                    Swal.fire({
                        title: 'Order Cancelled!',
                        text: response.message == "Single order confirmed successfully" ? "Single order Cancelled successfully" : response.message,
                        icon: 'success',
                        confirmButtonColor: '#3085d6',
                        timer: 2000, // Auto-close after 2 seconds
                        timerProgressBar: true, // Show progress bar
                        showConfirmButton: false, // Hide OK button (optional)
                        allowOutsideClick: false, // Prevent closing by clicking outside
                        allowEscapeKey: false, // Prevent closing with Escape key
                    });

                    // Trigger the onDeleteSuccess callback if provided
                    if (onCancleSuccess) {
                        onCancleSuccess();
                    }
                } catch (error) {
                    console.error('Error deleting item:', error);

                    // Show error pop-up
                    Swal.fire({
                        title: 'Error!',
                        text: error.message,
                        icon: 'error',
                        confirmButtonColor: '#3085d6',
                    });
                }
            }
        });
    };

    return (
        <a onClick={handleCancel} className="trashDeleteIcon" style={{ cursor: "pointer" }}>
            <em className="icon ni ni-cross-sm"></em>
        </a>
    );
};

export default CancelFun;